const g = "up", f = "down";
const m = (l, t, s) => {
  if (!t || !s)
    return;
  const i = t.clientHeight, n = t.scrollTop, o = s.clientHeight, c = s.offsetTop, e = c + o, a = n + i;
  switch (l) {
    case "up":
      c < n && (t.scrollTop = c - 4);
      break;
    case f:
      e > a && (t.scrollTop = e - i + 4);
      break;
  }
};
export {
  f as DOWN,
  g as UP,
  m as scrollItemIntoView
};
//# sourceMappingURL=scrollItemIntoView.js.map
